import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import TeamNumbersHome from './Index.vue';

// Aceleres -- tela administrativa "Números da Equipe".
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/team-numbers'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'team_numbers_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'team_numbers_list',
          // Área administrativa: só gestores/administradores. O item de menu já
          // é exibido apenas para eles; sem esta restrição um vendedor abria a
          // tela pela URL e via uma tabela sempre vazia (o escopo de
          // visibilidade nunca libera contatos fora da carteira dele).
          // Marcar/desmarcar continua liberado para quem pode editar o contato.
          meta: {
            permissions: ['administrator'],
          },
          component: TeamNumbersHome,
        },
      ],
    },
  ],
};
